import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"
import { InputTextarea } from "primereact/inputtextarea"

const DemoAccess = () => {

    return (
        <div className="flex flex-column gap-6 w-30rem flex-grow-1 xl:flex-grow-0">
            <div className="flex flex-column gap-1">
                <label htmlFor="username" style={{ color: "#727A99" }} className="text-base font-bold">Name</label>
                <InputText id="username" placeholder="Mobithera" value={null} className="w-full" style={{ borderRadius: "10px" }} />
            </div>

            <div className="flex gap-3 align-items-center">
                <div className="flex flex-column gap-1 w-full">
                    <label htmlFor="jobTitle" style={{ color: "#727A99" }} className="text-base font-bold">Job Title</label>
                    <InputText id="jobTitle" placeholder="Physician" value={null} className="w-full" style={{ borderRadius: "10px" }} />
                </div>
                <div className="flex flex-column gap-1 w-full">
                    <label htmlFor="email" style={{ color: "#727A99" }} className="text-base font-bold">E-mail</label>
                    <InputText id="email" placeholder="example@mail.com" value={null} className="w-full" style={{ borderRadius: "10px" }} />
                </div>
            </div>

            <div className="flex flex-column gap-1">
                <label htmlFor="message" style={{ color: "#727A99" }} className="text-base font-bold">How can we help?</label>
                <InputTextarea id="message" placeholder="Tell us briefly what you're looking for—clinic use, patient experience, integration, etc." autoResize rows={5} cols={30} className="w-full" style={{ borderRadius: "10px" }} />
            </div>

            <Button label="Submit" className="text-lg"
                style={{
                    color: "white",
                    backgroundColor: "#E3506B",
                    borderRadius: "10px",
                    fontWeight: 700,
                    height: "3rem",
                    width: "100%"
                }} />

        </div>
    )

}

export default DemoAccess